import type { AxiosResponse } from "axios";

import api from "../../../../../api";
import { downloadCSV, validateValues } from "../../utils";
import type { IUser } from "../../../../../types";
import { CommandFormValues } from "../../types";
import { exportTransactionsRequestSchema } from "./types";
import { SAVE_DATE_FORMAT } from "@/v1/constants";

export const handleExportTransactions = async (
  user: IUser,
  values: CommandFormValues
): Promise<AxiosResponse> => {
  const { dateRange } = validateValues(values, exportTransactionsRequestSchema);
  const [from, to] = dateRange.map((date) => date.format(SAVE_DATE_FORMAT));
  // Call the API method (GET) to export transactions.
  const response = await api.kontax.exportTransactions(user.id, from, to);
  // Extract the CSV
  const csv = response.data.csv;
  // Use the shared download helper to trigger the download.
  downloadCSV(csv, `transactions_${from}_${to}.csv`);
  return response;
};
